import { collection, onSnapshot, query, where } from "firebase/firestore";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../../firebase";
import RejectUser from "../../../Controllers/SuperAdmin/RejectUser";
import ApproveUser from "../../../Controllers/SuperAdmin/ApproveUser";

const SchoolViewModal = () => {
  const [AllUsers, setAllUsers] = useState();
  const [IsLoading, setIsLoading] = useState(true);
  const [Refresh, setRefresh] = useState(true);
  const [UserId, setUserId] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const q = query(collection(db, "Users"), where("UserType", "==", "admin"));

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const users = [];
      querySnapshot.forEach((doc) => {
        if (doc.id !== auth.currentUser.uid) {
          users.push({ id: doc.id, ...doc.data() });
        }
      });
      setIsLoading(false);
      setAllUsers([...users]);
    });

    return unsubscribe;
  }, []);

  //Reject user  Action Confirmation Start
  const [OpenRejectDialog, setOpenRejectDialog] = useState(false);

  const handleOpenRejectDialog = (id) => {
    setUserId(id);
    setOpenRejectDialog(true);
  };

  const handleRejectCloseDialog = async (del) => {
    setOpenRejectDialog(false);
    if (del === true) {
      let resp = await RejectUser(UserId);

      if (resp) {
        setOpenRejectDialog(false);
        setRefresh(!Refresh);
      }
    }
  };
  //Reject user Action Confirmation End

  //Approve  user  Action Confirmation Start
  const [OpenApproveDialog, setOpenApproveDialog] = useState(false);

  const handleOpenApproveDialog = (id) => {
    setUserId(id);
    setOpenApproveDialog(true);
  };

  const handleApproveCloseDialog = async (del) => {
    setOpenApproveDialog(false);
    if (del === true) {
      let resp = await ApproveUser(UserId);

      if (resp) {
        setOpenApproveDialog(false);
        setRefresh(!Refresh);
      }
    }
  };
  //Approve user Action Confirmation End

  return {
    AllUsers,
    navigate,
    OpenRejectDialog,
    handleOpenRejectDialog,
    handleRejectCloseDialog,
    IsLoading,
    OpenApproveDialog,
    handleOpenApproveDialog,
    handleApproveCloseDialog,
  };
};

export default SchoolViewModal;
